import type { DateTime } from 'luxon';

interface Filters
{
    datetime(value: DateTime | Date | string, format?: string, zone?: string): string;
    date(value: DateTime | Date | string, format?: string, zone?: string): string;
    time(value: DateTime | Date | string, format?: string, zone?: string): string;
    baseurl(value: string): string;
    image(value: string, presetName: string): string;
    filesize(size: number): string;
    default(value: string, defaultValue: string): string;
}

class FiltersHelper implements Filters
{
    public datetime(value: DateTime | Date | string, format: string = 'yyyy-MM-dd HH:mm:ss', zone: string = null): string
    {
        return formatDateTime(value, format, zone);
    }

    public date(value: DateTime | Date | string, format: string = 'yyyy-MM-dd', zone: string = null): string
    {
        return formatDateTime(value, format, zone);
    }

    public time(value: DateTime | Date | string, format: string = 'HH:mm:ss', zone: string = null): string
    {
        return formatDateTime(value, format, zone);
    }

    public baseurl(value: string): string
    {
        return baseurl(value);
    }

    public image(value: string, presetName: string): string
    {
        return baseurl(`${value}?p=${presetName}`);
    }

    public filesize(size: number): string
    {
        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let i = 0;

        for (i = 0; size > 1024; i++)
        {
            size = size / 1024;
        }

        return `${units[i] == 'B' ? size : size.toFixed(2)} ${units[i]}`;
    }

    public default(value: string, defaultValue: string): string
    {
        return value || defaultValue;
    }
}

export default defineNuxtPlugin({
    name: 'filters',
    dependsOn: [],
    async setup(nuxtApp)
    {
        const helper = new FiltersHelper() as Filters;

        return {
            provide: {
                filters: helper
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $filters: Filters;
    }
}
